import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';
import { ResellerTokenResponse } from '@utils/types/resellers/reseller-token.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetTokens = () => {
  const { t } = useTranslation();
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchTokens = async () => {
    const { tokens: tokensUrl } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });
    const { data } = await Axios.get<ResellerTokenResponse>(tokensUrl);
    return data;
  };

  return useQuery<ResellerTokenResponse, AxiosError<BaseError>>(
    ['tokens', offset, limit, qString, sortField, sortDirection],
    fetchTokens,
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      keepPreviousData: true,

      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,

      onError: error => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const d = error.response?.data as any;
        const msg =
          d?.error_description ||
          d?.detail ||
          d?.error ||
          d?.message ||
          t('an-error-has-occurred');
        toast.error(String(msg));
      }
    }
  );
};
